
  import {Component, Vue} from "vue-property-decorator";

  import attach_module from "@/modules/Attachments";
  import user_service from '@/modules/user'

  import {AttachmentColumns} from "@/modules/Attachments/metadata";

  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import Dropdown from 'primevue/dropdown';
  import FileUpload from "primevue/fileupload";
  import DataTable from "primevue/datatable";
  import Column from "primevue/column";
  import ProgressBar from "primevue/progressbar";

  Vue.component("Dialog", Dialog);
  Vue.component("Dropdown", Dropdown);
  Vue.component("Button", Button);
  Vue.component("FileUpload", FileUpload);
  Vue.component("DataTable", DataTable);
  Vue.component("Column", Column);
  Vue.component("ProgressBar", ProgressBar);

  @Component
  export default class AttachmentsPDF extends Vue {
    lead_id: string | (string | null)[] = this.$route.query.id;
    public attachmentColumns = AttachmentColumns;
    files: Array<string> = [];

    intervalUpdateFiles: any

    public tableMenu = [
      {
        name: "Edit",
        label: "edit",
      },
      {
        name: "Delete",
        label: "delete",
      },
    ];
    public manuItem = "";
    public defaultSortingColumn = 'Created';
    public defaultSortingType:any = -1;
    public paginationPage = 0

    selectedDataForDeleting: any = null
    displayDelDialog: boolean = false

    get APPSTORE(){
      return user_service.APPSTORE;
    }

    public atts:any[] = []
    refreshTableKey = 0

    get attachments() {
      console.log(">>>>> *** attachments: ", attach_module.attachments)

      let isActiveStatus = false

      const rows = attach_module.attachments.map((el: any) => {
        const attach = el
        try {
          const parsed = JSON.parse(el.Info);
          const info = parsed[0] ? parsed[0] : parsed;
          attach.Name = info.FileName
          attach.Size = info.Size
        } catch (e) {
          // console.warn("Parse Info was failed: ", e)
        }
        if(attach.Status === "INWORK") isActiveStatus = true
        return attach
      })

      // return rows

      // merge block to exclude the autoscrolling
      // TODO: should be optimized
      if (!this.atts.length) this.atts = rows
      else {
        const rl = rows.length

        // for deleting and updating rows
        let al = this.atts.length
        for (let i = 0; i < al; i++) {
          let isChanged = false
          for (let j = 0; j < rl; j++) {
            if (this.atts[i].Id === rows[j].Id) {
              isChanged = true
              this.atts[i] = rows[j]
            }
          }
          if(!isChanged) {
            this.atts.splice(i, 1)
            al--
            i--
          }
        }

        // for adding new rows
        al = this.atts.length
        for (let j = 0; j < rl; j++) {
          let isExist = false
          for (let i = 0; i < al; i++ ) {
            if (this.atts[i].Id === rows[j].Id) {
              isExist = true
            }
          }
          if(!isExist) {
            this.atts.push(rows[j])
          }
        }
      }

      // if (!isActiveStatus) clearInterval(this.intervalUpdateFiles)

      this.refreshTableKey++;
      console.log("|||||| this.$refs.homeTable: ", this.$refs.homeTable)

      // this.$refs.homeTable.value = this.atts

      return this.atts
    }

    async created() {

      if(localStorage['CURRENT_SORTING_COLUMN_IN_ATTACHMENTS_TABLE'])
        this.defaultSortingColumn = localStorage['CURRENT_SORTING_COLUMN_IN_ATTACHMENTS_TABLE']
      if(localStorage['CURRENT_SORTING_TYPE_IN_ATTACHMENTS_TABLE'])
        this.defaultSortingType = Number(localStorage['CURRENT_SORTING_TYPE_IN_ATTACHMENTS_TABLE'])
      if(localStorage['CURRENT_PAGINATION_PAGE_IN_ATTACHMENTS_TABLE'])
        this.paginationPage = Number(localStorage['CURRENT_PAGINATION_PAGE_IN_ATTACHMENTS_TABLE'])

      // setTimeout(() => this.$refs.homeTable.paginate(this.paginationPage), 1000)

      // await attach_module.getAttachments(this.lead_id);
      await attach_module.getAttachments2();

      this.intervalUpdateFiles = setInterval(() => attach_module.getAttachments2(), 10000);

      //@ts-ignore
      document.getElementsByClassName('p-fileupload-buttonbar')[0].children[1].style.display = "none";

      //@ts-ignore
      document.getElementsByClassName('p-fileupload-buttonbar')[0].children[2].style.display = "none";

      console.log(">>>>>>> this.$refs.attachmentsUpload: ", document.getElementsByClassName('p-fileupload-buttonbar')[0].children)
    }

    fixStatusText(text: string){

      if (text && text.toLocaleLowerCase() === 'faulted'){
        return 'FAILED';
      }
      return text;
    }

    timestampPrepare(time: string) {
      if (!time || time.length !== 14) return "";
      return (
        time.slice(0, 4) +
        "-" +
        time.slice(4, 6) +
        "-" +
        time.slice(6, 8) +
        " " +
        time.slice(8, 10) +
        ":" +
        time.slice(10, 12) +
        ":" +
        time.slice(12, 14)
      );
    }

    prepareSize(s: string|number) {
      const b = Number(s)
      return Number(b/1024/1024).toFixed(2) + ' Mb'
    }

    async onUpload(event: any) {
      console.log("UPLOADER", event)
      this.$toast.add({
          severity: 'success',
          summary: 'File uploaded!',
          life: 2000
        });
      const files = event.files.filter(
        (el: any) => !this.files.includes(String(el.name) + String(el.size))
      );

      // files.forEach(async (f: any) => {
      //   await attach_module.uploadFile({f: f, rowID: this.lead_id})
      //   this.files.push(String(f.name) + String(f.size));
      // });

      await attach_module.uploadFile({f: files[0], rowID: this.lead_id})
      this.files.push(String(files[0].name) + String(files[0].size));

      clearInterval(this.intervalUpdateFiles)
      attach_module.getAttachments2()
      this.intervalUpdateFiles = setInterval(() => attach_module.getAttachments2(), 10000);
      // @ts-ignore
      this.$refs.attachmentsUpload.files = [];
    }

    editItem(data: any) {
      this.openFile(data['Id'])
    }

    openFile(id: string, onlyPDF?: boolean) {
      clearInterval(this.intervalUpdateFiles)
      this.$router.push(`/file?id=${id}&onlyPDF=${onlyPDF ? true : false}`)
    }

    prepareToDeleting(data: any){
      console.log(">>>>>>>> prepareToDeleting: ", data)
      this.selectedDataForDeleting = data
      this.displayDelDialog = true
    }

    async deleteItem(data?: any) {
      if (!data) data = this.selectedDataForDeleting
      console.log('deleteItem', data.data.Id)

      try {
        await attach_module.deleteAttachments(data.data.Id);
        await attach_module.getAttachments2();
        clearInterval(this.intervalUpdateFiles)
        this.intervalUpdateFiles = setInterval(() => attach_module.getAttachments2(), 10000);
      } catch (err) {
        console.log("Deleting was failed");
      }

      this.cancelDelDialog()
    }

    cancelDelDialog() {
      this.displayDelDialog = false
      this.selectedDataForDeleting = null
    }

    setPage(e: any) {
      console.log('>>>>>>>>> page event: ', e)
      this.paginationPage = e.first
      localStorage['CURRENT_PAGINATION_PAGE_IN_ATTACHMENTS_TABLE'] = e.first
    }

    logout(){
      user_service.logout()
      this.$router.push("/login")
    }

    onSort(e: any) {
      console.log(">>>>>>>>> Attachments ---> onSort ---> e: ", e)
      this.defaultSortingColumn = e.sortField
      this.defaultSortingType = e.sortOrder
      localStorage['CURRENT_SORTING_COLUMN_IN_ATTACHMENTS_TABLE'] = e.sortField
      localStorage['CURRENT_SORTING_TYPE_IN_ATTACHMENTS_TABLE'] = e.sortOrder
      this.paginationPage = Number(this.paginationPage)
    }

    destroy() {
      clearInterval(this.intervalUpdateFiles)
    }
  }
